import { render } from "./folderstudy.vue?vue&type=template&id=86f6b8be&scoped=true"
import script from "./folderstudy.vue?vue&type=script&lang=js"
export * from "./folderstudy.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./folderstudy.vue?vue&type=style&index=1&id=86f6b8be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f6b8be"]])

export default __exports__